import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"color":"#fb8c00"} }
const _hoisted_2 = {
  key: 0,
  class: "pi pi-angle-down w-4 h-4"
}
const _hoisted_3 = { class: "w-full background-orange-lighten-5 py-2 px-5 gap-4 grid grid-cols-6 items-center my-1" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "col-span-2 md:col-span-4" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-primary font-bold text-sm sm:text-base" }, "Total Pendapatan Jadwal")
], -1)
const _hoisted_5 = { class: "col-span-2 md:col-span-1" }
const _hoisted_6 = { class: "color-primary font-bold text-sm sm:text-base" }
const _hoisted_7 = { style: {} }
const _hoisted_8 = { class: "color-primary font-bold text-sm sm:text-base" }
const _hoisted_9 = { class: "w-full background-grey-lighten-5 py-2 px-5 gap-4 grid grid-cols-6 justify-between items-center" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "col-span-2 md:col-span-4" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold text-sm sm:text-base" }, "Total Yang Diterima")
], -1)
const _hoisted_11 = { class: "col-span-4 md:col-span-2" }
const _hoisted_12 = {
  key: 1,
  class: "flex justify-between bg-white rounded-lg py-1 px-2 w-full",
  style: {"border":"1px solid #CFD8DC"}
}
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold text-sm sm:text-base" }, "Rp.", -1)
const _hoisted_14 = { class: "color-blue-grey font-bold text-sm sm:text-base" }
const _hoisted_15 = {
  key: 0,
  class: "flex w-full justify-between"
}
const _hoisted_16 = { class: "font-semibold" }
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = { class: "flex w-full justify-center" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "font-bold text-white" }, "Simpan Keterangan", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxScrolling = _resolveComponent("DxScrolling")
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")
  const _component_DxColumn = _resolveComponent("DxColumn")
  const _component_DxGroupPanel = _resolveComponent("DxGroupPanel")
  const _component_DxGrouping = _resolveComponent("DxGrouping")
  const _component_DxPaging = _resolveComponent("DxPaging")
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_DxDataGrid, {
      class: "data-grid-table-finished",
      "column-auto-width": true,
      "allow-column-reordering": false,
      "show-column-lines": false,
      "show-row-lines": true,
      "show-borders": true,
      "row-alternation-enabled": true,
      "allow-column-resizing": false,
      "word-wrap-enabled": true,
      "data-source": _ctx.dataSource,
      "key-expr": "Id"
    }, {
      "cell-highlighted": _withCtx(({ data }) => [
        _createVNode("div", {
          class: "cursor-pointer",
          onClick: ($event: any) => (_ctx.showDetail(data.data.Id))
        }, [
          _createVNode("p", _hoisted_1, _toDisplayString(data.data.Resi), 1)
        ], 8, ["onClick"])
      ]),
      cellTemplate: _withCtx(({ data }) => [
        _createVNode("div", {
          class: "cursor-pointer flex items-center gap-2 w-full",
          style: `color: ${data.data.StatusPengecekan.Warna}`,
          onClick: ($event: any) => (_ctx.showPanelStatus(data.data, $event))
        }, [
          _createVNode("i", {
            class: `pi ${data.data.StatusPengecekan.Icon} w-4 h-4`
          }, null, 2),
          _createTextVNode(" " + _toDisplayString(data.data.StatusPengecekanId ? data.data.StatusPengecekan.Status : "-") + " ", 1),
          (!_ctx.dataHeader.IsClose)
            ? (_openBlock(), _createBlock("i", _hoisted_2))
            : _createCommentVNode("", true)
        ], 12, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxScrolling, { mode: "virtual" }),
        _createVNode(_component_DxColumnChooser, {
          enabled: true,
          mode: "select",
          title: "Pilih Kolom",
          "allow-search": true
        }),
        _createVNode(_component_DxColumn, {
          "group-index": 0,
          "data-field": "Agent",
          "min-width": 170
        }),
        _createVNode(_component_DxColumn, {
          "group-index": 1,
          "data-field": "Manifest",
          "min-width": 200
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Resi",
          caption: "No. Resi",
          "min-width": 200,
          "css-class": "cell-highlighted",
          "cell-template": "cell-highlighted"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NamaChecking",
          caption: "Admin HO",
          "min-width": 150
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NamaPengirim",
          caption: "Pengirim",
          "min-width": 150
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "HpPengirim",
          caption: "No. Pengirim",
          visible: false,
          width: 130
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NamaPenerima",
          caption: "Penerima",
          visible: false,
          "min-width": 150
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "HpPenerima",
          caption: "No. Penerima",
          visible: false,
          width: 130
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NamaAgenAsal",
          caption: "Ag. Asal",
          visible: false,
          "min-width": 150
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NamaAgenTujuan",
          caption: "Ag. Tujuan",
          visible: false,
          "min-width": 150
        }),
        _createVNode(_component_DxColumn, {
          caption: "Status",
          "cell-template": "cellTemplate",
          "min-width": 200,
          "css-class": "cell-status",
          "data-field": "NamaStatusPengecekan"
        }),
        _createVNode(_component_DxColumn, {
          "min-width": 150,
          "data-field": "KeteranganCheckScan",
          caption: "Keterangan Scan"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Tunai",
          caption: "Tunai",
          "min-width": 150
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NonTunai",
          caption: "Non Tunai",
          "min-width": 150
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "KomisiAgen",
          caption: "Komisi Agen",
          visible: false,
          width: 200
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "KomisiKru",
          caption: "Komisi Kru",
          visible: false,
          width: 200
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Keterangan",
          caption: "No Referensi"
        }),
        _createVNode(_component_DxGroupPanel, {
          visible: true,
          "empty-panel-text": "Drag kolom ke sini untuk mengelompokkan menurut kolom tersebut"
        }),
        _createVNode(_component_DxGrouping, {
          "auto-expand-all": _ctx.autoExpandAll,
          "context-menu-enabled": true,
          "expand-mode": "rowClick"
        }, null, 8, ["auto-expand-all"]),
        _createVNode(_component_DxPaging, {
          "page-size": 10,
          enabled: false
        }),
        _createVNode(_component_DxSearchPanel, { visible: false })
      ]),
      _: 1
    }, 8, ["data-source"]),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("p", _hoisted_6, _toDisplayString(`Rp. ${new Number(_ctx.sumTunai).toLocaleString("id-ID")}`), 1)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("p", _hoisted_8, _toDisplayString(`Rp. ${new Number(_ctx.sumNonTunai).toLocaleString("id-ID")}`), 1)
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode("div", _hoisted_11, [
          (!_ctx.dataHeader.IsClose)
            ? (_openBlock(), _createBlock(_component_InputNumber, {
                key: 0,
                id: "totalReceivedId",
                class: "input-primary rounded-lg w-full",
                modelValue: _ctx.totalReceived,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.totalReceived = $event)),
                modelModifiers: { lazy: true },
                mode: "currency",
                currency: "IDR",
                currencyDisplay: "code",
                locale: "id-ID"
              }, null, 8, ["modelValue"]))
            : (_openBlock(), _createBlock("div", _hoisted_12, [
                _hoisted_13,
                _createVNode("p", _hoisted_14, _toDisplayString(`${new Number(_ctx.totalReceived).toLocaleString("id-ID")}`), 1)
              ]))
        ])
      ])
    ]),
    _createVNode("div", null, [
      _createVNode(_component_Textarea, {
        autoResize: true,
        id: "descriptionTableFinishedId",
        modelValue: _ctx.descriptionTableFinished,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.descriptionTableFinished = $event)),
        rows: "2",
        class: "md:w-1/2 w-full rounded-lg input-primary mb-0 mt-4",
        placeholder: "Keterangan",
        disabled: _ctx.dataHeader.IsClose
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _createVNode(_component_OverlayPanel, {
      ref: "refStatusPengecekan",
      class: "p-4",
      style: {"max-width":"200px"}
    }, {
      default: _withCtx(() => [
        _createVNode("div", null, [
          _createVNode("div", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataStatusPengecekanResi.filter(
              x => x.Id !== _ctx.dataChoiceDelivery.StatusPengecekanId
            ), (item) => {
              return (_openBlock(), _createBlock("div", {
                class: "flex items-center mb-2 cursor-pointer gap-2",
                key: item.Id,
                onClick: ($event: any) => (_ctx.choiceStatusFromDropDown(item))
              }, [
                _createVNode("i", {
                  class: `pi ${item.Icon}`,
                  style: { color: item.Warna }
                }, null, 6),
                _createVNode("p", {
                  class: "text-sm font-semibold",
                  style: { color: item.Warna }
                }, _toDisplayString(item.Status), 5)
              ], 8, ["onClick"]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Dialog, {
      header: "Header",
      class: "dialog-confirm",
      visible: _ctx.isShowModalDesc,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowModalDesc = $event)),
      modal: true
    }, {
      header: _withCtx(() => [
        (_ctx.dataChoiceStatus)
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _createVNode("p", _hoisted_16, _toDisplayString(_ctx.dataChoiceStatus.Status), 1),
              _createVNode("i", {
                class: "pi pi-times cursor-pointer",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideDialogModalDesc && _ctx.hideDialogModalDesc(...args)))
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createVNode("div", _hoisted_18, [
          _createVNode(_component_Button, {
            class: "btn-primary p-button-sm flex gap-2 cursor-pointer",
            onClick: _ctx.submitData
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_17, [
          _createVNode(_component_Textarea, {
            modelValue: _ctx.valueDescription,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.valueDescription = $event)),
            autoResize: true,
            class: "w-full keterangan-change-label mt-2 input-primary",
            cols: "50",
            rows: "4"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}